import {
  INCIDENT_FORM_LIST,
  UPDATE_INCIDENT_FORM,
  UPLOAD_INCIDENT_FORM,
  GET_ADDED_QUESTIONS,
  DELETE_INCIDENT_QUESTION,
  UPDATE_INCIDENT_FORM_QUES,
  EDIT_INICIDENT_FORM_ADMIN,
  SUBMIT_ADMIN_REVIEWD_FORM,
  GET_ALL_INCIDENT_FORM_DATA,
  GET_OLD_INCIDENT_FORMS,
  SEND_MAIL,
  INCIDENT_LOGS,
  ARRANGE_INICIDENT_QUES_ORDER,
} from "./actionTypes";
import {
  getIncidentListSuccess,
  getIncidentListFail,
  uploadIncidentFormSuccess,
  uploadIncidentFormFail,
  updateIncidentFormSuccess,
  updateIncidentFormFail,
  getAddedQuestionsSuccess,
  getAddedQuestionsFail,
  deleteIncidentQuesFail,
  deleteIncidentQuesSuccess,
  updateIncidentFormQuesSuccess,
  updateIncidentFormQuesFail,
  editIncidentFormAdminSuccess,
  editIncidentFormAdminFail,
  submitAdminReviewedFormSuccess,
  submitAdminReviewedFormFail,
  getAllIncidentFormDataSuccess,
  getAllIncidentFormDataFail,
  getOldIncidentFormsFail,
  getOldIncidentFormsSuccess,
  sendMailForIncidentSuccess,
  sendMailForIncidentFail,
  incidentLogsSuccess,
  incidentLogsFail,
  arrangeIndicentQuesOrderSuccess,
  arrangeIndicentQuesOrderFail,
} from "./actions";
import {
  getIncidentFormsList,
  uploadAdminIncidentForm,
  updateAdminIncidentForm,
  getAddedIncidentForms,
  removeIncidentQues,
  updateAdminIncidentFormQues,
  reviewIncidentForm,
  submitReviewedIncidentForm,
  getIncidentFormsData,
  getIncidentFormsOld,
  sendEmailForIncident,
  updateIncidentQuesOrder,
  onGettingIncidentLogs,
} from "helpers/fakebackend_helper";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

const toastTitle = "Incident Form";

function* Edit_Incident_form_Admin({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(reviewIncidentForm, data);
    yield call(responseHandler, "Incident form", response, editIncidentFormAdminSuccess, editIncidentFormAdminFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(editIncidentFormAdminFail(error));
    showToast("error", "Error", error);
  }
}

function* Get_Incident_Form_All_Data({ payload: data }) {
  try {
    const response = yield call(getIncidentFormsData, data);
    yield put(getAllIncidentFormDataSuccess(response));
  } catch (error) {
    yield put(getAllIncidentFormDataFail(error));
    showToast("error", "Error", error);
  }
}

function* Get_Old_Incident_Forms({ payload: data }) {
  try {
    const response = yield call(getIncidentFormsOld, data);
    yield put(getOldIncidentFormsSuccess(response));
  } catch (error) {
    yield put(getOldIncidentFormsFail(error));
    showToast("error", "Error", error);
  }
}

function* Get_Incident_Form_Added_questions({ payload: data }) {
  try {
    const response = yield call(getAddedIncidentForms, data);
    yield put(getAddedQuestionsSuccess(response));
  } catch (error) {
    yield put(getAddedQuestionsFail(error));
    showToast("error", "Error", error);
  }
}

function* FetchIncidentFormList({ payload: data }) {
  try {
    const response = yield call(getIncidentFormsList, data);
    yield put(getIncidentListSuccess(response));
  } catch (error) {
    yield put(getIncidentListFail(error));
  }
}

function* onGetLogs({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingIncidentLogs, data);
    yield call(responseHandler, toastTitle, response, incidentLogsSuccess, incidentLogsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(incidentLogsFail(error));
    showToast("error", toastTitle, error);
  }
}

function* SendMailForIncidentReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(sendEmailForIncident, data);
    yield call(responseHandler, toastTitle, response, sendMailForIncidentSuccess, sendMailForIncidentFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(sendMailForIncidentFail(error));
    showToast("error", "Sending Mail", error);
  }
}

function* Remove_Incident_Ques({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(removeIncidentQues, data);
    yield call(responseHandler, toastTitle, response, deleteIncidentQuesSuccess, deleteIncidentQuesFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteIncidentQuesFail(error));
    showToast("error", "Incident Form", error);
  }
}

function* Submit_Reviewed_IncidentForm({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(submitReviewedIncidentForm, data);
    yield call(responseHandler, toastTitle, response, submitAdminReviewedFormSuccess, submitAdminReviewedFormFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(submitAdminReviewedFormFail(error));
    showToast("error", "Incident Form", error);
  }
}

function* UploadIncidentForm({ payload: data }) {
  try {
    const response = yield call(uploadAdminIncidentForm, data);
    yield put(uploadIncidentFormSuccess(response));
    showToast("success", "Incident Report", response.message);
  } catch (error) {
    yield put(uploadIncidentFormFail(error));
    showToast("error", "Incident Report", error);
  }
}

function* UpdateIncidentForm({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(updateAdminIncidentForm, data);
    yield call(responseHandler, toastTitle, response, updateIncidentFormSuccess, updateIncidentFormFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateIncidentFormFail(error));
    showToast("error", "Incident Report", error);
  }
}

function* UpdateIncidentFormQues({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(updateAdminIncidentFormQues, data);
    yield call(responseHandler, toastTitle, response, updateIncidentFormQuesSuccess, updateIncidentFormQuesFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateIncidentFormQuesFail(error));
  }
}

function* UpdateQuesOrder({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(updateIncidentQuesOrder, data);
    yield call(responseHandler, toastTitle, response, arrangeIndicentQuesOrderSuccess, arrangeIndicentQuesOrderFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(arrangeIndicentQuesOrderFail(error));
  }
}

export function* watchFunctions() {
  yield takeEvery(INCIDENT_FORM_LIST, FetchIncidentFormList);
  yield takeEvery(ARRANGE_INICIDENT_QUES_ORDER, UpdateQuesOrder);
  yield takeEvery(UPLOAD_INCIDENT_FORM, UploadIncidentForm);
  yield takeEvery(UPDATE_INCIDENT_FORM, UpdateIncidentForm);
  yield takeEvery(GET_ADDED_QUESTIONS, Get_Incident_Form_Added_questions);
  yield takeEvery(DELETE_INCIDENT_QUESTION, Remove_Incident_Ques);
  yield takeEvery(UPDATE_INCIDENT_FORM_QUES, UpdateIncidentFormQues);
  yield takeEvery(EDIT_INICIDENT_FORM_ADMIN, Edit_Incident_form_Admin);
  yield takeEvery(SUBMIT_ADMIN_REVIEWD_FORM, Submit_Reviewed_IncidentForm);
  yield takeEvery(GET_ALL_INCIDENT_FORM_DATA, Get_Incident_Form_All_Data);
  yield takeEvery(GET_OLD_INCIDENT_FORMS, Get_Old_Incident_Forms);
  yield takeEvery(SEND_MAIL, SendMailForIncidentReport);
  yield takeEvery(INCIDENT_LOGS, onGetLogs);
}

function* Register() {
  yield all([fork(watchFunctions)]);
}

export default Register;
